module.exports = __webpack_public_path__ + "static/media/no_data_transfer.2f03a288.svg";